import { GlossaryList } from 'humanity/components/glossaryList';
import { retirementGlossaryProps } from 'humanity/pages/retirementGlossary/retirementGlossary.types.js';
import { SimpleMasthead } from 'humanity/sections/simpleMasthead';

const RetirementGlossary = ({ sections, glossaryList }) => (
  <>
    {sections.map((section) => {
      switch (section.__typename) {
        case 'SimpleMasthead':
          return <SimpleMasthead {...section} />;
        default:
          return null;
      }
    })}
    <GlossaryList list={glossaryList} />
  </>
);

RetirementGlossary.propTypes = {
  ...retirementGlossaryProps,
};

export default RetirementGlossary;
